import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { AttributeDatatype } from 'app/mdm/terminology-lib/services/attribute-datatype';
import { Dictionary, DictionaryConcept, DictionaryVersion } from 'app/mdm/terminology-lib/services/dictionary';
import { MessageService } from '@heda/core-hospital-ui';

@Component({
  templateUrl: './dictionary-version-view.component.html',
})
export class DictionaryVersionViewComponent implements OnInit {
  public maxAttributes = 5;
  public dictionary: Dictionary;
  public version: DictionaryVersion;

  private dictionaryId: string;
  private versionNumber: number;

  constructor(
    private dictionaryService: DictionaryService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private location: Location,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.dictionaryId = this.route.snapshot.paramMap.get('dictId');
    this.versionNumber = Number(this.route.snapshot.paramMap.get('vers'));

    this.dictionaryService.getDictionary(this.dictionaryId).subscribe((r) => (this.dictionary = r));
    this.dictionaryService.getVersion(this.dictionaryId, this.versionNumber).subscribe((r) => (this.version = r));
  }

  public update(): void {
    this.dictionaryService.updateVersion(this.version, this.dictionaryId, this.versionNumber).subscribe(
      () => {
        this.messageService.success('core.msg.save.success');
      },
      (err) => {
        this.messageService.error('core.msg.save.error');
      }
    );
  }

  public formatAttributeValue(attributeId: string, concept: DictionaryConcept): string {
    if (!concept || !concept.attributes || !concept.attributes[attributeId]) {
      return '';
    }
    const value = concept.attributes[attributeId];
    const attr = this.dictionary.attributes.find((a) => a.id === attributeId);
    if (attr.datatype === AttributeDatatype.translations) {
      return value[this.getCurrentLang()];
    }
    return value;
  }

  public deleteConcept(conceptCode: string): void {
    this.dictionaryService.removeConcept(this.dictionaryId, this.versionNumber, conceptCode).subscribe(() => {
      this.version.concepts = this.version.concepts.filter((c) => c.code !== conceptCode);
    });
  }

  public isNullOrInFuture(date: Date): boolean {
    return date == null || date > new Date();
  }

  getCurrentLang(): string {
    return this.translateService.currentLang;
  }

  goBack(): void {
    this.location.back();
  }
}
